import { useEffect, useRef } from 'react'

import { RichTextEditor, RichTextEditorHandle } from '@factorialco/f0-react/dist/experimental'

import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import i18n from 'modules/core/lib/i18n'

interface RichTextEditorProps {
  onDiscard: () => void
  disableDiscard?: boolean
  onChange: (result: string) => void
  onSave: () => void
  noteText: string
  initialNoteText?: string
  title?: string | null
}

function RitchTextEditorForNotes({
  onDiscard,
  disableDiscard = false,
  onChange,
  onSave,
  noteText,
  initialNoteText = '',
  title = null,
}: RichTextEditorProps) {
  const { editorConfig, loading: loadingRichTextEditor } = useRichTextEditor()
  const noteTextTrimmed = noteText.trim()
  const richTextEditorRef = useRef<RichTextEditorHandle>(null)

  useEffect(() => {
    if (!loadingRichTextEditor && richTextEditorRef.current) {
      richTextEditorRef.current?.setContent(initialNoteText)
      richTextEditorRef.current?.focus()
    }
  }, [loadingRichTextEditor, initialNoteText])

  return (
    <>
      {loadingRichTextEditor ? (
        <RichTextEditor.Skeleton rows={1} />
      ) : (
        <RichTextEditor
          ref={richTextEditorRef}
          {...editorConfig}
          maxCharacters={10000}
          onChange={(result) => {
            onChange(result?.value ?? '')
          }}
          placeholder={i18n.t('complaints.overview.internal_notes.note_placeholder')}
          primaryAction={{
            action: {
              label: i18n.t('complaints.overview.internal_notes.note_submit'),
              onClick: onSave,
              variant: 'default',
              disabled: noteTextTrimmed === '' || noteTextTrimmed === initialNoteText,
            },
          }}
          secondaryAction={[
            {
              label: i18n.t('complaints.overview.internal_notes.note_discard'),
              onClick: onDiscard,
              disabled: disableDiscard,
              type: 'button',
              variant: 'outline',
            },
          ]}
          title={title || i18n.t('complaints.overview.internal_notes.add_note')}
          initialEditorState={{ content: initialNoteText }}
        />
      )}
    </>
  )
}

export default RitchTextEditorForNotes
